import { BdsIconEyeglasses } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";

import "./NotificationPanelHeaderWebview.less";

interface INotificationPanelHeaderWebviewProps {
    isLoading: boolean;
    onMarkAllReadAsync: () => Promise<void>;
}

export function NotificationPanelHeaderWebview({
    isLoading,
    onMarkAllReadAsync,
}: Readonly<INotificationPanelHeaderWebviewProps>) {
    return (
        <BTRow
            data-testid="PanelTitle"
            className="NotificationPanelHeader NotificationPanelHeader--webview"
            justify="center"
            align="middle"
        >
            <div className="flex-grow-1 text-right">
                <BTButton
                    data-testid="markAllRead"
                    aria-label="Mark all read"
                    icon={<BdsIconEyeglasses />}
                    onClick={onMarkAllReadAsync}
                    disabled={isLoading}
                    className="MarkAllReadButton HeaderButton"
                    type="tertiary"
                >
                    Mark all read
                </BTButton>
            </div>
        </BTRow>
    );
}
